import { Splide } from '@splidejs/splide'
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll'
import isEmail from 'validator/lib/isEmail'
import parsePhoneNumber from 'libphonenumber-js'
import $ from 'jquery'

const ctaButton = document.querySelectorAll('.cta a')

ctaButton.forEach((elm) => {
  elm.addEventListener('click', (event) => {
    if (window.innerWidth > 840) {
      event.target.setAttribute('href', '#')
    } else {
      event.target.setAttribute('href', '#contact-form')
    }
  })
})

// 実績のスライダー
achievementSlider()
function achievementSlider() {
  const slider = (slideElement, speed = 0.8) => {
    const splide = new Splide(slideElement, {
      type: 'loop',
      arrows: false,
      fixedWidth: '18rem',
      gap: '1.6rem',
      pagination: false,
      drag: false,
      autoScroll: {
        speed: speed,
        pauseOnHover: false,
      },
      mediaQuery: 'max',
      breakpoints: {
        839: {
          gap: '0.8rem',
        },
      },
    }).mount({
      AutoScroll,
    })
  }

  slider('.achievements__auto-scroll--top')
  slider('.achievements__auto-scroll--bottom', -0.8)
}

// お問い合わせフォームの処理
contactForm()
function contactForm() {
  let step = 0 // ステップはインデックス番号で管理
  const url = new URL(window.location.href)
  const urlParams = url.searchParams
  const formData = {}

  // url パラメーター source に値があれば流入元の情報を formData に入れる
  if (urlParams.get('source')) {
    formData['event_source'] = urlParams.get('source')
  } else {
    formData['event_source'] = 'not_found'
  }

  const formButton = document.querySelector('.form-button')
  const formStatusChip = document.querySelectorAll('.form-status span')
  const formStepWrapper = document.querySelectorAll('.step-wrapper')
  const inputUserPrefecture = document.querySelector('#user_prefecture')
  const inputUserBorn = document.querySelector('#user_born')
  const inputUserName = document.querySelector('#user_name')
  const inputUserEducation = document.querySelector('#user_education')
  const inputUserTel = document.querySelector('#user_tel')
  const inputUserEmail = document.querySelector('#user_email')
  const confirmUserPrefecture = document.querySelector('.value--prefecture')
  const confirmUserBorn = document.querySelector('.value--born')
  const confirmUserName = document.querySelector('.value--name')
  const confirmUserEducation = document.querySelector('.value--education')
  const confirmUserTel = document.querySelector('.value--tel')
  const confirmUserEmail = document.querySelector('.value--email')
  const privacyText = document.querySelector('form p.privacy')
  const prevButton = document.querySelector('form p.form-prev-button')

  const validation = (inputElement, tel = false, email = false) => {
    const value = inputElement.value
    const inputWrapper = inputElement.parentElement
    const errorText = inputWrapper.nextElementSibling

    if (errorText) errorText.remove()

    // 要素が空の時の判定
    if (value === '') {
      inputWrapper.insertAdjacentHTML(
        'afterend',
        '<p class="error">入力してください</p>'
      )

      return false
    }

    if (tel) {
      const phoneNumber = parsePhoneNumber(value, 'JP')

      try {
        if (!phoneNumber.isValid()) {
          inputWrapper.insertAdjacentHTML(
            'afterend',
            '<p class="error">正しい電話番号を入力してください</p>'
          )

          return false
        } else {
          inputElement.value = phoneNumber.formatNational()
        }
      } catch (error) {
        inputWrapper.insertAdjacentHTML(
          'afterend',
          '<p class="error">半角数字で入力してください</p>'
        )

        return false
      }
    }

    if (email) {
      if (!isEmail(value)) {
        inputWrapper.insertAdjacentHTML(
          'afterend',
          '<p class="error">正しいメールアドレスを入力してください</p>'
        )

        return false
      }
    }

    // オブジェクトのデータを渡す
    formData[inputElement.name] = inputElement.value

    return true
  }

  const changeStatus = (index) => {
    if (index < 3) {
      formStatusChip.forEach((element) => {
        element.classList.remove('active')
      })

      formStatusChip[index].classList.add('active')
    }
  }

  const changeForm = (index) => {
    formStepWrapper.forEach((element) => {
      element.classList.remove('active')
    })

    formButton.innerText = '次に進む'
    privacyText.setAttribute('hidden', '')
    prevButton.setAttribute('hidden', '')
    formStepWrapper[index].classList.add('active')

    if (0 < index) {
      prevButton.removeAttribute('hidden')
    }

    if (index === 2) {
      formButton.innerText = '入力内容を確認する'
    }

    if (index === 3) {
      privacyText.removeAttribute('hidden')
      formButton.innerText = '送信する'
    }
  }

  // フォームの初期化
  changeForm(step)
  changeStatus(step)

  // 次に進むボタンを押したときの処理
  formButton.addEventListener('click', (event) => {
    if (step === 0) {
      const prefectureValidate = validation(inputUserPrefecture)
      const bornValidate = validation(inputUserBorn)

      if (prefectureValidate && bornValidate) {
        step++

        changeForm(step)
        changeStatus(step)

        return
      }
    }

    if (step === 1) {
      const nameValidate = validation(inputUserName)
      const educationValidate = validation(inputUserEducation)

      if (nameValidate && educationValidate) {
        step++

        changeForm(step)
        changeStatus(step)

        return
      }
    }

    if (step === 2) {
      const telValidate = validation(inputUserTel, true)
      const emailValidate = validation(inputUserEmail, false, true)

      if (telValidate && emailValidate) {
        step++

        changeForm(step)
        changeStatus(step)

        // 確認画面に入力したデータを全て入れる
        confirmUserPrefecture.innerText = formData['user_prefecture']
        confirmUserBorn.innerText = formData['user_born']
        confirmUserName.innerText = formData['user_name']
        confirmUserEducation.innerText = formData['user_education']
        confirmUserTel.innerText = formData['user_tel']
        confirmUserEmail.innerText = formData['user_email']

        return
      }
    }

    // 送信の処理
    if (step === 3) {
      // メールを送信
      const spinner = `
        <div class="sending-mail">
          <div class="half-circle-spinner">
            <div class="circle circle-1"></div>
            <div class="circle circle-2"></div>
          </div>送信中です
        </div>
      `
      event.target.setAttribute('disabled', '')
      event.target.innerText = ''
      event.target.insertAdjacentHTML('afterbegin', spinner)

      // gasにデータを送信
      sendData('./app/gas/gas.php', formData)
      // メールを送信
      sendData('./app/mail/sendMail.php', formData, () => {
        location.href = `./thanks/?user_name=${formData['user_name']}`
      })

      return
    }
  })

  // 戻るボタンを押したときの処理
  prevButton.addEventListener('click', () => {
    if (0 < step) {
      step--

      changeForm(step)
      changeStatus(step)
    }
  })
}

function sendData(url, postData, cb) {
  $.ajax({
    type: 'post',
    url: url,
    dataType: 'json',
    data: postData,
  })
    .done((data) => {
      if (data.result) {
        if (cb) {
          cb()
        }
      } else {
        alert('送信が失敗しました。お手数ですが再度お手続きをお願いいたします')
      }
    })
    .fail((jqXHR, textStatus, errorThrown) => {
      // iPhoneだと2回目のPOSTのタイミングでfailのブロックに入ってしまうのでalertはコメントアウト
      // alert('送信が失敗しました。お手数ですが再度お手続きをお願いいたします')
      console.log('通信が失敗しました')
      console.log(`jqXHR: ${jqXHR}`)
      console.log(`textStatus: ${textStatus}`)
      console.log(`errorThrown: ${errorThrown}`)
    })
}
